import { JT } from "./jumbotronTokens";

// Presentational status pill. The pulsing dot is FUNCTIONAL (game in progress);
// it is disabled under reduced motion — the static pill still conveys LIVE.
// 11px: the Readable Floor (DESIGN.md) -- every ticket reads its status here.
export default function StatusPill({ label, color, dim, live, reducedMotion }) {
  const pulse = live && !reducedMotion;
  return (
    <span style={{
      display:"inline-flex", alignItems:"center", gap:6,
      background:dim, color, fontSize:11, fontWeight:900, letterSpacing:"1.5px",
      borderRadius:JT.radius.pill, padding:"3px 9px",
    }}>
      <span data-testid="status-dot" style={{
        width:7, height:7, borderRadius:"50%", background:color,
        animation: pulse ? "stPulse 1.6s ease-out infinite" : undefined,
      }}/>
      {label}
    </span>
  );
}
